import { BaseDevice, CustomLayout } from '../../base_device'
import list_icon from '@/assets/img/device/fe87/icon.png'
import { DevicePid, EffectIndex, KK } from '@/define/define'
import { LightEffectMode, LightEffectModeType } from '@/define/light'
import { na87VKCodes } from './../keycode/vkeycode'
import { getDeviceKeySquare } from './../keysquare/keysquare'

export class FE87V2 extends BaseDevice {
  name: string = 'Fe87_V2_KeyBoard_Switch'
  icon: string = list_icon
  width: number = 777
  magneticAxis: boolean = false

  lightEffectList: { [name: LightEffectModeType]: EffectIndex } = {
    [LightEffectMode.Static_pro]: 3,
    [LightEffectMode.SaturatedStyle_FE87]: 0,
    [LightEffectMode.Prosperity_FE87]: 1,
    [LightEffectMode.SpinningWindmill_1]: 6,
    [LightEffectMode.Scanning_2]: 5,

    // [LightEffectMode.ClickHighlight_pro]: 0x11,
    // [LightEffectMode.ShadowChase_pro]: 0x12,
    // [LightEffectMode.KeyRipple_pro]: 0x14,

    [LightEffectMode.SideStatic]: 0x0,
    [LightEffectMode.SideFleeting]: 0x1,
    [LightEffectMode.SideSpectrumCycle]: 0x2,
    [LightEffectMode.SideBreathing]: 0x3,
  }
  rate: number[] = [8, 4, 2, 1]

  superResponse: boolean = false
  inoperableKeys: KK[] = [0x55, 0x00]

  y_number: number = 10
  vkcodes = na87VKCodes
  square = getDeviceKeySquare(DevicePid.IROKNA87)

  minDelayTimer: number = 1
  maxDelayTimer: number = 4095

  resetDes = ''
  fnDisableKeys: KK[] = [0x0, 0x1, 0x2, 0x3, 0x4, 0x5, 0x6, 0x7, 0x8, 0x9, 0xa, 0xb, 0xc, 0x12, 0x13, 0x14, 0x53, 0x54, 0x31, 0x32, 0x51, 0x1b, 0x2c, 0x42, 0x4c, 0x58, 0x5a, 0x59]

  customLayout: CustomLayout = {
    0x01: this.createSquare(41),
    0x05: this.createSquare(17, 2),

    0x10: this.createSquare(2, this.y_number),
    0x11: this.createSquare(2, this.y_number),
    0x12: this.createSquare(2, this.y_number),
    0x13: this.createSquare(2, this.y_number),
    0x14: this.createSquare(2, this.y_number),
    0x15: this.createSquare(2, this.y_number),
    0x16: this.createSquare(2, this.y_number),
    0x17: this.createSquare(2, this.y_number),
    0x18: this.createSquare(2, this.y_number),
    0x19: this.createSquare(2, this.y_number),
    0x1a: this.createSquare(2, this.y_number),
    0x1b: this.createSquare(2, this.y_number),
    0x1c: this.createSquare(2, this.y_number),
    0x1d: this.createSquare(2, this.y_number, 67.5),
    0x1e: this.createSquare(10, this.y_number),
    0x1f: this.createSquare(2, this.y_number),
    0x3f: this.createSquare(2, this.y_number),
    0x09: this.createSquare(17, 2),
    0x0d: this.createSquare(10, 2),

    0x20: this.createSquare(2, 2, 48),
    0x2d: this.createSquare(2, 2, 59),
    0x2e: this.createSquare(10, 2),
    0x30: this.createSquare(2, 2, 55),
    0x3c: this.createSquare(2, 2, 93.5),
    0x40: this.createSquare(2, 2, 76),
    0x4b: this.createSquare(2, 2, 114),
    0x55: this.createSquare(2, 2, 54),
    0x57: this.createSquare(2, 2, 54),
    0x56: this.createSquare(2, 2, 54),
    0x4c: this.createSquare(54, 0),

    0x50: this.createSquare(2, 2, 54),
    0x52: this.createSquare(2, 2, 54),
    0x51: this.createSquare(2, 2, 54),
    0x53: this.createSquare(2, 2, 215),
    0x54: this.createSquare(2, 2, 54),
    0x58: this.createSquare(13, 0),
    0x59: this.createSquare(2, 0),
    0x5a: this.createSquare(2, 0),
  }

  keyboardDebounce: number[] = fe87KeyboardDebounce()
}

const fe87KeyboardDebounce = () => {
  const res = []
  for (let i = 1; i <= 30; i++) {
    res.push(i)
  }
  return res
}
